<template>
  <div class="scroll-container-outer">
    <span
      :class="{ 'is-visible': showLeftArrow }"
      class="scroll-btn scroll-btn-left"
      @click="scrollLeft"
    >
      <i class="el-icon-arrow-left" />
    </span>
    <el-scrollbar ref="scrollContainer" :vertical="false" class="scroll-container" @wheel.native.prevent="handleScroll">
      <slot />
    </el-scrollbar>
    <span
      :class="{ 'is-visible': showRightArrow }"
      class="scroll-btn scroll-btn-right"
      @click="scrollRight"
    >
      <i class="el-icon-arrow-right" />
    </span>
  </div>
</template>

<script>
const tagAndTagSpacing = 4 // tagAndTagSpacing
const SCROLL_STEP = 200 // 每次点击箭头滚动的像素距离

export default {
  name: 'ScrollPane',
  data() {
    return {
      left: 0,
      showLeftArrow: false,
      showRightArrow: false
    }
  },
  computed: {
    scrollWrapper() {
      return this.$refs.scrollContainer.$refs.wrap
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollWrapper.addEventListener('scroll', this.updateArrow, true)
      this.updateArrow()
    })
  },
  beforeDestroy() {
    this.scrollWrapper.removeEventListener('scroll', this.updateArrow)
  },
  methods: {
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 40
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4
    },
    emitScroll() {
      this.$emit('scroll')
    },
    /** 更新左右箭头可见性 */
    updateArrow() {
      const $scrollWrapper = this.scrollWrapper
      if (!$scrollWrapper) return
      const scrollLeft = $scrollWrapper.scrollLeft
      const scrollWidth = $scrollWrapper.scrollWidth
      const clientWidth = $scrollWrapper.clientWidth
      // 内容超出容器才显示箭头
      const hasOverflow = scrollWidth > clientWidth + 1
      this.showLeftArrow = hasOverflow && scrollLeft > 0
      this.showRightArrow = hasOverflow && (scrollLeft + clientWidth < scrollWidth - 1)
    },
    /** 向左滚动 */
    scrollLeft() {
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft = Math.max(0, $scrollWrapper.scrollLeft - SCROLL_STEP)
    },
    /** 向右滚动 */
    scrollRight() {
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft = Math.min(
        $scrollWrapper.scrollWidth - $scrollWrapper.clientWidth,
        $scrollWrapper.scrollLeft + SCROLL_STEP
      )
    },
    moveToTarget(currentTag) {
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      const $scrollWrapper = this.scrollWrapper
      const tagList = this.$parent.$refs.tag

      let firstTag = null
      let lastTag = null

      // find first tag and last tag
      if (tagList.length > 0) {
        firstTag = tagList[0]
        lastTag = tagList[tagList.length - 1]
      }

      if (firstTag === currentTag) {
        $scrollWrapper.scrollLeft = 0
      } else if (lastTag === currentTag) {
        $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth
      } else {
        // find preTag and nextTag
        const currentIndex = tagList.findIndex(item => item === currentTag)
        const prevTag = tagList[currentIndex - 1]
        const nextTag = tagList[currentIndex + 1]

        // the tag's offsetLeft after of nextTag
        const afterNextTagOffsetLeft = nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing

        // the tag's offsetLeft before of prevTag
        const beforePrevTagOffsetLeft = prevTag.$el.offsetLeft - tagAndTagSpacing

        if (afterNextTagOffsetLeft > $scrollWrapper.scrollLeft + $containerWidth) {
          $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth
        } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
          $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-container-outer {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 34px;
}
.scroll-btn {
  position: absolute;
  z-index: 10;
  width: 24px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 2px;
  color: #909399;
  font-size: 12px;
  top: 3px;
  opacity: 0;
  pointer-events: none;
  transition: opacity .2s;
  &.is-visible {
    opacity: 0.85;
    pointer-events: auto;
    &:hover {
      opacity: 1;
      color: #409eff;
      border-color: #c6e2ff;
      background: #ecf5ff;
    }
  }
  &-left {
    left: 2px;
  }
  &-right {
    right: 2px;
  }
}
.scroll-container {
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  width: 100%;
  ::v-deep {
    .el-scrollbar__bar {
      bottom: 0px;
    }
    .el-scrollbar__wrap {
      height: 49px;
    }
  }
}
</style>
